export default __webpack_public_path__ + "static/media/banner-bg-light2.6504b388.png";